webpackJsonp([248707572166302],{

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(97);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_React$Component) {
	    _inherits(IndexPage, _React$Component);
	
	    function IndexPage() {
	        _classCallCheck(this, IndexPage);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    IndexPage.prototype.render = function render() {
	        var data = this.props.data;
	
	        var blogs = data.allContentstackBlogs.edges;
	        console.log("blogs", blogs);
	        return _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            blogs.map(function (edge) {
	                return _react2.default.createElement(
	                    'div',
	                    { key: edge.node.id, className: 'blogs' },
	                    _react2.default.createElement(
	                        'section',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'blog-title' },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                edge.node.title
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'blog-description' },
	                            edge.node.short_title,
	                            _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                {
	                                    to: edge.node.url
	                                },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' Read more '
	                                )
	                            )
	                        )
	                    )
	                );
	            })
	        );
	    };
	
	    return IndexPage;
	}(_react2.default.Component);
	
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blogs-js-5fffd21af518e44b4341.js